import axios from 'axios';
import store from './store/store';
import router from './router';
import iView from 'view-design';
// axios 配置
axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/file';
// axios.defaults.baseURL = '/services';
axios.defaults.baseURL = '/jg/services';
// if(localStorage.getItem('access_token')){
//     axios.defaults.headers.common['Authorization'] = 'Bearer '+ localStorage.getItem('access_token');
// }
// http request 拦截器
axios.interceptors.request.use(
    config => {
        if (store.state.users.token) {
            config.headers.Authorization = store.state.users.token;
        }
        // config.headers['x-tif-uid']='1o0a8cjrllbi0um2v0z8sz';
        return config;
    },
    err => {
        return Promise.reject(err);
    });

// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 401 清除token信息并跳转到登录页面
                    // iView.Message.error('您已被登出, 请重新登录');
                    store.dispatch('users/clearCache');
                    break;
                case 403:
                    // 403 无权限，跳转到首页
                    router.replace({
                        name: 'base',
                        query: {redirect: router.currentRoute.fullPath}
                    });
                    break;
                case 404:
                    // iView.Message.error('请求错误！');
                    break;
                case 500:
                    iView.Message.error('服务器异常！');
                    break;
                default:
                    iView.Message.error('网络异常！');
            }
        }
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        /*return Promise.reject(error.response.data)*/
        return Promise.reject(error);
    });

export default axios;
